<div class="container text-center py-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <img src="/images/logo/Referio.png" alt="Logo Referio" width="100" class="mb-4" />

      <h1 class="display-4 fw-bold text-danger">404</h1>
      <p class="lead text-muted mb-4">Oups... La page que vous cherchez n'existe pas ou a été déplacée.</p>

      <a routerLink="/" class="btn btn-primary btn-lg me-2">
        <i class="bi bi-house-door-fill me-1"></i> Retour à l'accueil
      </a>
      <a href="mailto:support@referio.com" class="btn btn-outline-secondary btn-lg">
        <i class="bi bi-envelope-fill me-1"></i> Contacter le support
      </a>

      <div class="mt-5">
        <p class="text-muted small">Code d'erreur : <strong>404 - Not Found</strong></p>
      </div>
    </div>
  </div>
</div>